import React from 'react';
import './Dossierheadercdq.css'; // Importe le CSS
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Dossierheadercdq() {
  return (
    <div className="header-containerga24">
        <div className="boutton-containerga24">
                <div className='butga190'>
                  
             <button className="bouttonga24">GALERIE<ArrowForwardIcon className="24arrow-icon" />CHEFS DE QUARTIERS ET CDQ</button>
             <h1>CHEFS DE QUARTIERS ET CDQ</h1> 
            </div>
            </div>
    </div>
  );
}

export default Dossierheadercdq;


